/**
 * API Configuration
 * 
 * This file contains all API-related configuration settings.
 * Update the BASE_URL based on your environment.
 */

import { BASE_URL as IMPORTED_BASE_URL } from "../constants/BaseUrl";

// Re-export BASE_URL for use throughout the application
export const BASE_URL = IMPORTED_BASE_URL;

// Base URL for the backend API
// export const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

// API endpoints
export const API_ENDPOINTS = {
  LOGIN: "auth/login",
  LOGOUT: "auth/logout",
  SIGNUP: "auth/signup",
  NONPROFIT_SIGNUP: "auth/signup/nonprofit",
  VERIFY_EMAIL: "auth/verify-email",
  VERIFY_EMAIL_BYPASS: "auth/verify-email-bypass",
  RESEND_VERIFICATION_OTP: "auth/resend-verification-otp",
  NONPROFIT_EVENTS_LIST: "nonprofit/events",
  NONPROFIT_CREATE_EVENT: "nonprofit/create-event",
  NONPROFIT_UPDATE_EVENT: "nonprofit/event-detail",
  NONPROFIT_COPY_EVENT: "nonprofit/event-copy",
  NONPROFIT_DELETE_EVENT: "nonprofit/event-delete",
  NONPROFIT_DIRECTORY: "nonprofits",
  NONPROFIT_CREATE_COLLABORATION_REQUEST: "nonprofit/collaboration-requests",
  NONPROFIT_GET_RECEIVED_REQUESTS: "nonprofit/collaboration-requests/received",
  NONPROFIT_GET_SENT_REQUESTS: "nonprofit/collaboration-requests/sent",
  NONPROFIT_ACCEPT_COLLABORATION_REQUEST: "nonprofit/collaboration-requests",
  NONPROFIT_REJECT_COLLABORATION_REQUEST: "nonprofit/collaboration-requests",
  NONPROFIT_GET_COLLABORATION_REQUEST: "nonprofit/collaboration-requests",
  NONPROFIT_GET_COLLABORATION_REQUEST_BY_EVENT: "nonprofit/collaboration-requests/event",
  NONPROFIT_ADD_TASK: "nonprofit/collaboration-requests",
  NONPROFIT_FLAG_EVENT: "nonprofit/flagged-events",
  NONPROFIT_GET_PROFILE: "nonprofits/profile/me",
  NONPROFIT_UPDATE_PROFILE: "nonprofits/profile/me",
  USERS_ME: "users/me",
  DELETE_MY_ACCOUNT: "users/me/delete",
  UPLOAD_IMAGE: "storage/upload/image",
  UPLOAD_USER_DOCUMENT: "users/me/documents/upload",
  GET_USER_DOCUMENTS: "users/me/documents",
  DELETE_USER_DOCUMENT: "users/me/documents",
  UPDATE_DOCUMENT_VISIBILITY: "users/me/documents",
  GET_REJECTION_REASON: "auth/rejection-reason",
  FORGOT_PASSWORD_OTP: "auth/forgot-password-otp",
  VERIFY_PASSWORD_OTP: "auth/verify-password-otp",
  RESET_PASSWORD_OTP: "auth/reset-password-otp",
  GET_LOVS_PUBLIC: "lovs/public",
  GET_LOVS: "lovs",
  GET_USER_SERVICES: "lovs/user-services",
  GET_CHAT_MESSAGES: "nonprofit/chat/threads",
  GET_CHAT_THREAD_ID: "nonprofit/chat/threads",
  GET_DASHBOARD_ANALYTICS: "nonprofits/dashboard/analytics",
  GET_EVENTS_CHART: "nonprofits/dashboard/events-chart",
  GET_RESOURCE_USAGE: "nonprofits/dashboard/resource-usage",
  GET_RECENT_ACTIVITIES: "nonprofits/dashboard/recent-activities",
  GET_IMPACT_DASHBOARD: "nonprofits/dashboard/impact",
  EVENT_INQUIRIES: "event-inquiries",
  EVENT_INQUIRIES_CONVERSATION: "event-inquiries",
  INQUIRIES: "inquiries",
  INQUIRIES_BY_EVENT: "inquiries/event",
  // Admin Inquiries
  ADMIN_INQUIRIES: "admin-inquiries",
  ADMIN_INQUIRIES_MY: "admin-inquiries/my",
  ADMIN_INQUIRY_MESSAGES: "admin-inquiries",
  // Announcements (super admin popup for NonProfit on login)
  ACTIVE_ANNOUNCEMENT: "superadmin/announcements/active",

  // Nonprofit Resources (Manage Resources)
  NONPROFIT_RESOURCES: "nonprofit/resources",

  // Resource Inquiries
  RESOURCE_INQUIRIES: "resource-inquiries",

  // Assistants
  ASSISTANTS: "nonprofit/assistants",

  // Notifications
  NOTIFICATIONS: "notifications",
  NOTIFICATIONS_UNREAD_COUNT: "notifications/unread-count",
  NOTIFICATIONS_MARK_READ: "notifications/mark-read",
  NOTIFICATIONS_DEVICE_TOKEN: "notifications/device-token",
  NOTIFICATIONS_DEVICE_TOKEN_REMOVE: "notifications/device-token/remove",
};

// Request timeout (in milliseconds)
export const REQUEST_TIMEOUT = 30000;

// Default headers
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

